import { service } from './service'; // 获取送货单列表

export function GetOrderList(params) {
  return service({
    url: 'DnBarcode/SearchDeliveryNoteData',
    params: params,
    method: 'get'
  });
} // 生成内箱标签

export function CreateInnerBoxCodeData(data) {
  return service({
    url: 'DnBarcode/CreateInnerBoxCodeData',
    data: data,
    method: 'post'
  });
} // 生成物料明细

export function CreatePartDetailData(data) {
  return service({
    url: 'DnBarcode/CreatePartDetailData',
    data: data,
    method: 'post'
  });
} // 保存数据

export function SaveData(data) {
  return service({
    url: 'DnBarcode/SaveData',
    data: data,
    method: 'post'
  });
} // 查询列表数据

export function LoadData(data) {
  return service({
    url: 'DnBarcode/LoadData',
    data: data,
    method: 'post'
  });
} // 查询内箱标签--明细list

export function GetPartBarcodeDetailList(params) {
  return service({
    url: 'DnBarcode/GetPartBarcodeDetailList',
    params: params,
    method: 'get'
  });
} // 查询内箱标签--明细list

export function GetPartBarcodeDetailPageList(params) {
  return service({
    url: 'DnBarcode/GetPartBarcodeDetailPageList',
    params: params,
    method: 'get'
  });
} // 查询外箱标签List

export function GetBoxCodeDetailList(params) {
  return service({
    url: 'DnBarcode/GetBoxCodeDetailList',
    params: params,
    method: 'get'
  });
} // 生成外箱标签

export function CreateBoxCodeData(data) {
  return service({
    url: 'DnBarcode/CreateBoxCodeData',
    data: data,
    method: 'post'
  });
} // 获取外箱标签明细打印列表

export function GetBoxCodeDetailPrintData(params) {
  return service({
    url: 'DnBarcode/GetBoxCodeDetailPrintData',
    params: params,
    method: 'get'
  });
} // 导出数据
// export function ExportListData ({ ORGANIZE_ID, Page, Limit, LIST_ROUTE,ParamList }) {
//   return service({
//     url: `DnBarcode/ExportListData?Data.BILL_TYPE=1&Data.ORGANIZE_ID=${ORGANIZE_ID}&Page=${Page}&Limit=${Limit}&LIST_ROUTE=${LIST_ROUTE}&ParamList=${ParamList}`,
//     method: 'post'
//   })
// }

export function ExportListData(data) {
  return service({
    url: 'DnBarcode/ExportListData',
    method: 'post',
    data: data
  });
} // 删除

export function DeleteOneById(id) {
  return service({
    url: "DnBarcode/DeleteOneById?id=".concat(id),
    method: 'post'
  });
} // 下一张

export function GetLastById(params) {
  return service({
    url: 'DnBarcode/GetLastById',
    method: 'get',
    params: params
  });
} // 上一张

export function GetNextById(params) {
  return service({
    url: 'DnBarcode/GetNextById',
    method: 'get',
    params: params
  });
} // 导出内箱打码单据标签明细

export function ExportPartBarcodeData(params) {
  return service({
    url: 'DnBarcode/ExportPartBarcodeData',
    method: 'get',
    params: params
  });
} // 导出外箱打码单据标签明细

export function ExportBoxCodeData(params) {
  return service({
    url: 'DnBarcode/ExportBoxCodeData',
    method: 'get',
    params: params
  });
} // 生成外箱标签

export function CreatePartDetailDataOuterBox(data) {
  return service({
    url: 'DnBarcode/CreatePartDetailDataOuterBox',
    data: data,
    method: 'post'
  });
}